import ScrollTrigger from '@terwanerik/scrolltrigger';
import { ajax } from 'jquery';
import easing from 'jquery.easing';
import Swiper from 'swiper';
import swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/bundle';
import 'swiper/css/navigation';

// import Cookies from 'js-cookie';
// import lightcase from "lightcase";
// import 'lightcase/src/css/lightcase.css';


export class App {
  constructor(){
    this.html = document.documentElement;
    this.body = document.body;
    this.page = document.getElementById('page');
    this.header = document.getElementById('masthead');
				this.header_inner = this.header.querySelector('.site-header__inner');
				this.header_txtContainer = this.header.querySelector('.site-header__txtContainer');
    // this.navWrap = document.querySelector('.navWrap');
    this.gnav = document.getElementById('gnav');
    // this.btnWrap = document.getElementById('btnWrap');
    // this.logo = document.getElementById('siteBranding');

    this.winW = window.innerWidth;
    this.winH = window.innerHeight;
    this.headerH = this.header.offsetHeight;
    // this.logoH = this.logo.offsetHeight;
    // this.logoW = this.logo.offsetWidth;
    this.menuOpen = false;

    this.ua = ua;
    this.sp = 1000;
    this.ease = "easeInOutExpo";

    //一時非アクティブ処理
    
    // const cats_h = document.querySelectorAll('.catList-item_h a');
    // const taxes_f = document.querySelectorAll('.fnav-item.item-taxonomy a');
    // // console.log(taxes_f);
    // const ign_arr = [...cats_h, ...taxes_f];
    // ign_arr.forEach(
    //   _ign => {
    //     // console.log(_ign);
    //     _ign.classList.add('ign');
    //     _ign.href="#";
    //   }
    // )
    //一時非アクティブ処理
   


    if(this.body.classList.contains('post-type-archive-facility')){
      this.catListContainer = document.getElementById('catListContainer');
    }

    this.exc_s = document.querySelectorAll('.exc');
    // console.log(this.exc_s);
    if(this.html.lang === 'ja'){
      this.exc_s.forEach(
        _exc => {
          _exc.classList.remove('exc');
        }
      )
    }else{
      this.exc_s.forEach(
        _exc => {
          _exc.remove();
        }
      )
    }
    // console.log(this.ua);
  }

  wrapCharSpan(strs){
    return [...strs].map( tx => `<span>${tx}</span>`).join('');
  }

  init(){
    console.log('init');
    
   


    if(this.is_frontpage){

      // const nav_atags = this.gnav.querySelectorAll(".gnav-item a");
      // if(nav_atags.length){
      //   nav_atags.forEach(_a => {
      //     const _aNum = _a.href.indexOf('#');
      //     if(_aNum > 0){
      //       const _hash = "#"+_a.href.substring(_aNum+1);
      //       _a.href = _hash;
      //     }
      //   });
      // }
      

      // const listWrap = document.querySelector('.prListWrap');
      // listWrap.classList.add('pattern');
      //console.log(listWrap);



    }else{
      // const txs = this.header.querySelectorAll('.tx');
      // txs.forEach(
      //   _tx => {
      //    _tx.innerHTML = this.wrapCharSpan(_tx.textContent);
      //   }
      // )

      
      // const submenus = this.gnav.querySelectorAll('.sub-menu');
      // submenus.forEach( sub => {
      //   sub.outerHTML = `<div class='sub-menu-wrap'>${sub.outerHTML}</div>`;
      // });
      // const hasChildren = this.gnav.querySelectorAll('.item-hasChildren');
      // hasChildren.forEach( _child => {
      //   _child.addEventListener('mouseover', (e) => {
      //     const _tar = e.currentTarget;
      //     const sub_wrap = _tar.querySelector('.sub-menu-wrap');
      //     const sub_menu = _tar.querySelector('.sub-menu');
      //     if(!_tar.classList.contains('on')){
      //       _tar.classList.add('on');
      //       const sub_h = sub_menu.offsetHeight;
      //       sub_wrap.style.maxHeight = sub_h+"px";
      //     // console.log(sub_h);
      //     }
          
      //   });

      //   _child.addEventListener('mouseout', (e) => {
      //     const _tar = e.currentTarget;
      //     if(_tar.classList.contains('on')){
      //       _tar.classList.remove('on');
      //       const sub_wrap = _tar.querySelector('.sub-menu-wrap');
      //       sub_wrap.style.maxHeight = "0px";
      //     }
      //   });
      // });

      // this.navSp = this.navWrap.cloneNode(true);
      // this.navSp.classList.remove('navWrap');
      // this.navSp.classList.add('navSp');
      // this.navSp.querySelectorAll('.item-hasChildren').forEach( _child => {
      //   const _btnSub = document.createElement('span');
      //   _btnSub.classList.add('btnSub');
      //   _child.appendChild(_btnSub);
      //   _btnSub.addEventListener('click', (e) => {
      //     const _tar = e.currentTarget;
      //     if(_tar.classList.contains('on')){
      //       _tar.classList.remove('on');
      //       const _wrap = e.currentTarget.parentNode.querySelector('.sub-menu-wrap');
      //       _wrap.style.maxHeight = 0;
      //     }else{
      //       _tar.classList.add('on');
      //       const _wrap = e.currentTarget.parentNode.querySelector('.sub-menu-wrap');
      //       const _submenu = e.currentTarget.parentNode.querySelector('.sub-menu');
      //       _wrap.style.maxHeight = _submenu.offsetHeight + "px";
      //     }
      //   });
      // });
      // this.header.appendChild(this.navSp);

    }





    if(this.body.classList.contains('single') || 
    this.body.classList.contains('page')){
      const cases = document.querySelectorAll('.case');
      // cases.forEach(
      //   _case => {
      //     const _src = _case.querySelector('img').dataset.src;
      //     _case.outerHTML = `<a class='figureWrap' href='${_src}' data-rel="lightcase:case">${_case.outerHTML}<i class="fa fa-search" aria-hidden="true"></i></a>`;
      //   }
      // )
    }

    window.addEventListener('load', (e) => {
      $('.spinner').fadeOut('slow',function(){
        $(this).remove();
      });
      this.body.classList.add('loaded');
      this.page.classList.add('on');

      this.makeSwiper();

      if(this.body.classList.contains('home')){ 

      }

			// this.makeSp();

      this.resize();

      this.events();

      this.trigger();

    });
    
  //  this.makeSwiper();


  }

  setMovie(_yid){
    // this.ytPlayer;
    const start_s = 0;
    const end_s = 10;
    const _this = this;
 		
 			console.log(_yid);
 			// let starts = 0;
 			// let ends = 10;
     
 			this.ytPlayer = new YT.Player(
 				"mv",
 				{
 					width:0,
 					height:0,
 					videoId:_yid,
 					playerVars:{
 						//autoplay:1,
 						loop:1,
 						playlist:_yid,
 						rel:0,
 						fs: 0,
 						disablekb: 0,
 						playsinline:1,
 						modestbranding: 1,
 						iv_load_policy: 3,
 						controls:0,
 						showinfo:0,
 						wmode: "transparent"
 					},
 					events:{
 						onReady:onPlayerReady,
 						onStateChange:onStateChange
 					}
 				}
 			)
 		
 		function onPlayerReady(){
 			// console.log('ready');
 			document.body.classList.add('yt_ready');
      // this.ytPlayer.setPlaybackQuality('highres');
 			_this.ytPlayer.mute();
 			_this.ytPlayer.playVideo();
 			const poster = document.getElementById('poster');
 			setTimeout(e => {
 				poster.classList.add('off');
 			},1000);
 		}

 		function onPlayerStateChange(event) {
 			// console.log(event.data);
 		}

 		function onStateChange(state) {
 			// console.log('state');
 			// console.log(state.data);
 	  if (state.data === YT.PlayerState.ENDED) {
 	    _this.ytPlayer.loadVideoById({
 	      videoId: _yid,
 	      startSeconds: start_s,
 	      endSeconds:end_s
        });
      }
    }
    window.addEventListener('blur', (e)=>{
      //console.log(e.currentTarget);
      // console.log('blur');
    });
    window.addEventListener('focus', (e)=>{
      //console.log(e.currentTarget);
      // console.log('focus');
      // console.log(_this.ytPlayer);
      console.log(_this.ytPlayer.getPlayerState());
      const _state  =_this.ytPlayer.getPlayerState();
      if(_state == 2 || _state == 0 || _state == -1 || _state == 5){
        // console.log('play');
        _this.ytPlayer.playVideo();
      }

    });
    window.onpageshow = function(event) {
      console.log(event);
      if (event.persisted) {
           window.location.reload();
       }
  };
  }
  
  
  queryMatch(jud){
    // console.log(jud);
    if(jud === 'sp'){

    }else{
      if(this.body.classList.contains('post-type-archive-facility')){
        this.catListContainer.classList.remove('on');
        this.btn_cat.classList.remove('on');
      }
      // console.log(this.menuOpen);
    }
  }

  
  events(){
    window.addEventListener('scroll', (e) => { this.scroll(); });
    window.addEventListener('resize',(e)=>{this.resize();});

    


    if(typeof this.btn_sp != 'undefined' ){
      this.btn_sp.addEventListener('click',(e) => {
        // console.log('sp');
        if(this.header.classList.contains('on')){
          this.menuOff();
        }else{
          this.menuOn();
        }
      });
    }

   
    const atags = document.querySelectorAll("a[href^='#']");
    // console.log(atags);
    this.pageLink(atags);

    this.bet = 0;
    const options = {
      root:null,
      rootMargin:`${this.bet}px`,
      threshold: 0.1
    };

    const observer = new IntersectionObserver(entries => {
      entries.forEach(
        entry => {
          // console.log(entry.isIntersecting);
          // if(entry.isIntersecting){
          //   this.btnWrap.classList.remove('on');
          // }else{
          //   this.btnWrap.classList.add('on');
          // }
        //  if(entry.target.classList.contains('headerContainer')){
        //   // console.log(entry.intersectionRatio);
        //   if(entry.intersectionRatio < 0.1 ){
        //     // console.log(entry.intersectionRatio);
        //     // this.btn_pagetop.classList.add('on');
        //   }else{
        //     // console.log(entry.intersectionRatio);
        //     // this.btn_pagetop.classList.remove('on');
        //   }
        //  }

        }
      )
    }, options);

    //if(this.ua !== "mobile"){
      // this.ov_ttl = document.querySelector('.site-title');
      // observer.observe(this.ov_ttl);
    //}

				// this.btn_sp.addEventListener('click',(e) => {
    //     // console.log('sp');
    //     if(this.header.classList.contains('on')){
    //       this.menuOff();
    //     }else{
    //       this.menuOn();
    //     }
    //   });
      // this.menu_back.addEventListener('click', (e) => {
      //   this.menuOff();
      // });
    
    if(!this.body.classList.contains('home')){
      

      
    }else{// home
      // if(this.ua === "mobile"){
      //   const _secContainer = document.querySelector('.headerContainer');
      //   // observer.observe(_secContainer);
      // }
      // // console.log(observer);
      // const bnr_donation = document.getElementById('bnr_donation');
      // if(bnr_donation){
      // const sec_proc = document.querySelector('.sec-process');
      // // console.log(bnr_donation);
      // sec_proc.appendChild(bnr_donation);
      // bnr_donation.outerHTML = `<div class='bnrContainer mx-sp-500'>${bnr_donation.outerHTML}</div>`;
      // }

    }


    

    // if(this.body.classList.contains('contact')){
    //   const _form = document.querySelector('div[id ^= "mw_wp_form_mw-wp-form-"]');
    //   if(_form.classList.contains('mw_wp_form_input')){
    //     const _check = document.querySelector('input[type=checkbox]');
    //     const _btnContainer = document.getElementById('btnContainer');
    //     if(_check.checked){ _btnContainer.classList.add('on');}
        
    //     _check.addEventListener('click',(e)=>{
    //       if(e.currentTarget.checked){
    //         _btnContainer.classList.add('on');
    //       }else{
    //         _btnContainer.classList.remove('on');
    //       }
    //     });
    //   }
    // }

    // if(this.body.classList.contains('single') || 
    // this.body.classList.contains('page')){
    //   $('a[data-rel^=lightcase]').lightcase({
    //     maxHeight:2000,
    //     maxWidth:2000
    //   });
    // }



    const mediaQueryList = window.matchMedia('(min-width:897px)');
    const listener = (e) => {
      if(e.matches){
        this.queryMatch('pc');
        
      }else{
        this.queryMatch('sp');
      }
    }
    mediaQueryList.addEventListener('change', listener);

    listener(mediaQueryList);
    

  }
  
  pageLink(atg){
    const _atags = atg;
    for (const _a of _atags) {
          // console.log(_a);
      _a.addEventListener('click', (e) => {
        e.preventDefault();
        let href = e.currentTarget.getAttribute('href');
        if (href == "#" || href == "") {
          href = "#page";
          this.sp = 1200;
        }
        href = href.replace("#", "");
        const target = document.getElementById(href);
        setTimeout((e) => {
          this.anim(target);
        }, 100);
      });
    }
  }

  

  makeSp(){


    this.btn_sp = document.createElement('div');
    this.btn_sp.classList.add('btnSp');
    // this.btn_sp.classList.add('sp');
    this.btn_sp.innerHTML = `<div class='btnSp-inner'>
    <span class="bar"></span><span class="bar"></span><span class="bar"></span>
    </div><span class="txt">MENU</span>`;
    // this.header_inner.insertBefore(this.btn_sp, this.header.firstElementChild);
				this.header_inner.append(this.btn_sp);

    


    // this.menu_back = document.createElement('div');
    // this.menu_back.classList.add('navWrap-back');
    // this.navSp.appendChild(this.menu_back);
    
  }
  menuOff(){
			// console.log('off');
    this.menuOpen = false;
    this.header.classList.remove('on');
    this.btn_sp.querySelector('.bar:nth-child(1)').style.animationName = "bar1";
    this.btn_sp.querySelector('.bar:nth-child(3)').style.animationName = "bar3";
  }
  menuOn(){
    this.menuOpen = true;
    this.header.classList.add('on');
				// console.log(this.header.classList);
  }
  makeSwiper(){
     console.log('makeswiper')
    if(!this.body.classList.contains('single')){
      this.swipers = document.querySelectorAll('.swp');
    }else{
      console.log('single swiper');
      this.swipers = document.querySelectorAll('.swp');
    }
    console.log(this.swipers.length);
    if(this.swipers.length > 0){
      
      let swObj = {
        speed: 1000,
        loop: true,
        allowTouchMove: true,
        slidesPerView:1,
        autoplay:{
          delay:5000,disableOnInteraction:false
        }
      }
      let sw_cnt = 1;
      this.sw_arr = [];

      this.swipers.forEach(
        _swp => {
          //console.log(_swp);
          _swp.classList.add('sw'+sw_cnt);
          sw_cnt++;
        }
        
      );
      
      let sw_cnt2 = 1;
      this.swipers.forEach(
        swp => {
          if(swp.classList.contains('top_hero')){
            const sl_len = document.querySelectorAll('.swiper .swiper-slide').length;
           console.log(sl_len);
            if(sl_len == 1){
              swObj.loop = false;
              swObj.autoplay = false;
            }
            swObj.slidesPerView = 1;
            // swObj.parallax = true;
            swObj.speed = 2000;
            swObj.autoplay = {delay:5000,disableOnInteraction:false};
            swObj.effect= 'fade';
            
          }else{
            console.log('sw.length > 2 no hero');
            swObj.loop = true;
            swObj.slidesPerView = 1;
            swObj.autoplay = false;
            // swObj.autoplay = {delay:5000,disableOnInteraction:false}; //一時停止中
            swObj.effect= 'fade';
            swObj.breakpoints = {
              //897:{
              //   slidesPerView:4
              // },
              // 1001:{
              //   slidesPerView:4
              // },
            };
            swObj.navigation = {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            };
            swObj.pagination= {
              el: '.swiper-pagination',
              type: 'bullets',
              clickable: true
            };
            if(swp.classList.contains('top_sw')){
              swObj.effect='fade';
              swObj.autoplay = {delay:3000,disableOnInteraction:false};
            }
            if(swp.classList.contains('list_sw')){
              console.log('list sw');
               swObj.centeredSlides = true;
              swObj.slidesPerView = 'auto';
              // swObj.spaceBetween = 80;
              swObj.speed = 1000;
              swObj.autoplay = {delay:3000,disableOnInteraction:false};
              swObj.effect='slide';
            }
            if(swp.classList.contains('spot_sw')){
              swObj.speed = 1000;
              // swObj.autoplay = {delay:5000,disableOnInteraction:false};
              swObj.effect='slide';
              // swObj.allowTouchMove = false;
              // swObj.navigation = {
              //   nextEl: '.swiper-button-next-spot',
              //   prevEl: '.swiper-button-prev-spot'
              // };

              delete swObj.pagination;
            
            }
            // const swiper = new Swiper('.swiper',swObj);
          }

          if(swp.classList.contains('sw_shop')){
            swObj.pagination= {
              el: '.swiper-pagination',
              type: 'bullets',
              clickable: true
            };
          }

          if(swp.classList.contains('notice')){
            swObj.pagination = "";
            delete swObj.pagination;
          }
          
          if(swp.classList.contains('gp_sw')){
            // console.log(sw_delay)
            // swObj.autoplay = {delay:3000,disableOnInteraction:false};
            swObj.pagination= {
              el: '.swiper-pagination',
              type: 'bullets',
              clickable: true
            };
          }

          // console.log('.sw'+sw_cnt2);
          // console.log(sw_cnt2, swObj);
          const _swiper = new Swiper('.sw'+sw_cnt2,swObj);
          let _name = '';
          if(swp.classList.contains('spot_sw')){
            _name = 'spot_sw';
          }else{
            _name = 'sw'+sw_cnt2;
          }
          this.sw_arr[_name] = _swiper;
          // console.log(this.sw_arr);
          sw_cnt2++;
        }
      )
    }

    // const _ab_image = document.querySelectorAll('.about_sl.image');
    // // console.log(swObj_ab);
      
    // const _sw_ab_image = new Swiper('.about_sl.image',{
    //   speed: 1000,
    //   effect: 'fade',
    //   watchSlidesProgress:true,
    //   allowTouchMove: false
    // });

    // let swObj_ab = {
    //   speed: 1000,
    //   loop: true,
    //   effect: 'slide',
    //   allowTouchMove: true,
    //   slidesPerView:1,
    //   autoplay:{
    //     delay:5000
    //   },
    //   navigation:{
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev'
    //   },
    //   pagination:{
    //     el: '.swiper-pagination',
    //     type: 'bullets',
    //     clickable: true
    //   },
    //   thumbs: {
    //     swiper: _sw_ab_image,
    //   },
    // }

    // const _sw_ab_text = new Swiper('.about_sl.text',swObj_ab);

    
  }
  scroll(){
    if(!this.is_frontpage){
      // console.log(window.pageYOffset);
    }
  }
  resize(){
    this.get_size();
    // console.log(this.is_frontpage);
    // if(!this.is_frontpage){
      this.html.style.setProperty('--hh', this.headerH+"px");
      this.html.style.setProperty('--lgh', this.logoH+"px");
      this.html.style.setProperty('--lgw', this.logoW+"px");
      if(this.map){
        this.html.style.setProperty('--ctr',this.mapControll.offsetHeight+"px");
      }
    // }
   
  }
  get_size(){
    this.winW = window.innerWidth;
    this.winH = window.innerHeight;
    this.headerH = this.header.offsetHeight;
  }
  anim(_t,_tt=this.sp) {
    const rect = _t.getBoundingClientRect();
    const scT = window.pageYOffset || document.documentElement.scrollTop;
    let targetT  = rect.top;

    targetT = rect.top + scT;

    if(this.body.classList.contains('post-type-archive-facility')){
       // - this.headerH;
       targetT = rect.top + scT - this.headerH - this.catListContainer.offsetHeight;
      //  console.log(document.getElementById('catListContainer').offsetHeight);
    }
    // console.log(_tt);
    $('html,body').animate({
      scrollTop: targetT
    }, _tt, this.ease);
  }


  trigger(){
    this.trigger = new ScrollTrigger({
      trigger: {
        offset: {
          viewport: {
            x: 0,
            y: (trigger, rect, direction) => {
              return 0.1;
            }
          }
        },
        toggle: {
          callback: {
            in:(trigger)=>{
            },
            out:(trigger)=>{
            }
          }
        }
      }
    });
    this.trigger.add('[data-scroll]', {
      once: true,
      toggle: {
        class: {
          in: 'animIn',
          out: 'animOut'
        },
        callback: {
          in:(trigger) => {
            // if(trigger.element.classList.contains('img_circle')){
            //   setTimeout((e) => {
            //     console.log('beginElement');
            //     this.animate.beginElement();
            //     document.getElementById('img_circle').classList.add('on');
            //   },200);
            // }
          },
          out:(trigger) => {

          }
        }
      }
    })
  }
  
}
